import styled from "styled-components";

export const CalendarWrapper = styled.div<{ $darkMode?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  cursor: pointer;
  height: 35px;
  border-radius: 6px;
  padding: 0 8px;
  background: ${({ $darkMode }) => ($darkMode ? "#10101c" : "#fff")};
  border: ${({ $darkMode }) =>
    $darkMode
      ? "1px solid rgba(106, 113, 133, 0.2)"
      : "1px solid rgba(0, 0, 0, 0.12)"};
  color: ${({ $darkMode }) =>
    $darkMode ? "rgba(255, 255, 255, 0.8)" : "#111827"};
`;

export const CalendarIconButton = styled.button`
  background: none;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  padding: 0;
  cursor: pointer;

  i,
  svg {
    font-size: 20px;
    line-height: 1;
  }
`;

export const RangeLabel = styled.div`
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  text-decoration: underline;
  font-size: 12px;
  cursor: pointer;
  color: inherit;

  &:hover {
    opacity: 0.85;
  }
`;
